<template>
  <div class="list-filter-text">
    <h1 class="list-filter-text__heading">
      {{ heading }}
    </h1>
    <h2 class="list-filter-text__subheading">
      {{ subheading }}
    </h2>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TutorListFilterText',
  computed: {
    ...mapGetters('global', ['getMeta']),
    heading () {
      return this.getMeta?.heading
    },
    subheading () {
      return this.getMeta?.subheading
    }
  }
}
</script>

<style scoped lang="scss">
.list-filter-text {
  @apply relative w-full lg:w-[470px] text-center lg:text-left;
  &__heading{
    @apply text__headline-4-xs--bold lg:text__headline-4-md--bold text-title;
  }
  &__subheading{
    @apply text__headline-5-xs--regular lg:text__body-2-md--regular mt-2 text-body-1;
  }
}
</style>
